/**
 * The one definition of the public shared-app route shape.
 *
 * Used by the router, by the Share dialog when building a copyable absolute URL, and by the
 * bootstrap guards that skip auth-only setup on this route. Keep it the single source so those three
 * can never drift apart. Mirrors `SHARED_APP_PATH_PREFIX` in the backend's `schemas/app_share.py`.
 */
export const SHARED_APP_PATH_PREFIX = "/shared/apps/";

export function buildSharedAppPath(code: string): string {
  return `${SHARED_APP_PATH_PREFIX}${code}`;
}

/** The full URL to hand out, e.g. `https://acme.olivelabs.ai/shared/apps/<code>`. */
export function buildSharedAppUrl(code: string): string {
  return `${window.location.origin}${buildSharedAppPath(code)}`;
}

/**
 * Whether `pathname` is the public shared-app route.
 *
 * Drives the tenant-configuration bypass: that request only carries Cognito identifiers, which a
 * logged-out shared viewer has no use for, so it is not made at all on this route.
 */
export function isSharedAppPath(pathname: string): boolean {
  return pathname.startsWith(SHARED_APP_PATH_PREFIX);
}
